import React from "react";
import { createRoot } from "react-dom/client";

import TakeAwayArticles from "./articles-container/take-away-articles";
import { RecommendationData } from "../types/fragment";
import { StartLazyLoader } from "../util/lazy-loader";
import { TakeAwayArticlesProps } from "../types/articles";

if (typeof window.__PRELOADED_PRODUCT_RECOMMENDATION_STATE__ !== "undefined") {
  const propsTakeAwayArticles = JSON.parse(
    JSON.stringify(window.__PRELOADED_PRODUCT_RECOMMENDATION_STATE__)
  ) as TakeAwayArticlesProps;
  const rootTakeAwayArticles = createRoot(document.getElementById("scope-prs")!);
  rootTakeAwayArticles.render(<TakeAwayArticles {...propsTakeAwayArticles} />);
}

if (typeof window.__LAZY_LOADING_PRODUCT_RECOMMENDATION_STATE__ !== "undefined") {
  const recommendationData = JSON.parse(
    JSON.stringify(window.__LAZY_LOADING_PRODUCT_RECOMMENDATION_STATE__)
  ) as RecommendationData;

  const prsScopeContainers = document.querySelectorAll(".scope-lazy-prs");
  if (prsScopeContainers.length > 0) {
    StartLazyLoader(recommendationData, prsScopeContainers);
  }
}
